var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BuyoutOptionEvent',{attrs:{"form":_vm.form,"currencyCodes":_vm.currencyCodes,"assetComponent":_vm.assetComponent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }